export const visibilityReportKey = (companyId: number | null) => ['th', 'visibility-report', companyId] as const;

export const scanStatusKey = (companyId: number | null) => ['th', 'visibility-report', 'status', companyId] as const;

export const websiteResultsKey = (companyId: number | null) => ['th', 'visibility-report', 'results', companyId] as const;
